module.exports = __webpack_public_path__ + "media/images/admin/icons/volume-1-868e1073a6e6fe40af426dcd39a0268c.svg";